import { Contrato } from '@/shared/interfaces';
import { IDataProspecto } from '@/shared/interfaces/erp/prospecto';

export const calcLineaNameProspecto = (prospecto?: IDataProspecto) => {
  if (!prospecto?.id_prospecto) return 'N/A';

  const prospectoLinea = +(prospecto?.linea || 0);
  // const isBiggerThan1 = prospectoLinea > 1;
  const prospectoName = prospecto?.razon_social;

  // return isBiggerThan1 ? `${prospectoName}- L${prospectoLinea}` : prospectoName;

  return `${prospectoName}- L${prospectoLinea}`;
};

export const calcLineaNameContrato = (contrato: Contrato) => {
  if (!contrato?.id_contrato || !contrato?.cliente_data) return 'N/A';

  const contratoLinea = +(contrato?.linea || 0);
  const clienteName = contrato?.cliente_data?.razon_social;

  return `${clienteName} - L${contratoLinea}`;
};
